import '@hive/env/constant';
import '../types/types.d.ts';

import { setupGlobal } from '@hive/env/global';

setupGlobal();
